<template>
  <div>
    <div id="mainAsideTop">
      <el-row  type="flex" class="row-bg" justify="center" align="middle">
        <el-col :span="1"><p><img src="../../static/logo2.png"/></p></el-col>
        <el-col :span="12"><label id="mainAsideH">Cloud管理系统</label></el-col>
      </el-row>
    </div>
    <div style="height: 100%">
      <div id="mainLeftFixDiv">
        <h1>固定应用 <i class="el-icon-star-on"></i></h1>
        <el-divider></el-divider>
      </div>
      <el-menu
        default-active="0"
        class="el-menu-vertical-demo"
        v-if="items && items.length !== 0" v-bind="items" v-for="(item,index) in items" :key="index">
        <el-menu-item :key="item.id" @click.native="jumpCenter(item.id)">
          <template slot="title">
            <el-image :src='item.image'/>
            <label  class="itemLabel">{{item.name}}</label>
          </template>
        </el-menu-item >
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLeft',
  data () {
    return {
      input: '',
      items: [/*   {id: 0, name: 'Hfun Fly APP', image: '../../static/img/hfun_fly_logo.png'} */]
    }
  },
  beforeCreate () {
    this.bus.$on('busUpdateLeft', () => {
      this.getFixList()
    })
  },
  mounted () {
    this.getFixList()
  },
  methods: {
    getFixList () {
      this.$axios({
        url: this.$global.baseURL.concat('main/fixedSearch'),
        method: 'get'
      }).then(successResponse => {
        // console.log(successResponse.data.data)
        if (successResponse.data.code === 200) {
          // 重新刷新数据
          let tmpItems = []
          for (let i = 0; i < successResponse.data.data.length; i++) {
            tmpItems.push({id: successResponse.data.data[i].id,
              image: this.$global.baseURL.concat(successResponse.data.data[i].image),
              name: successResponse.data.data[i].name})
          }
          this.items = tmpItems
          this.$forceUpdate()
        } else {
        }
      })
    },
    jumpCenter (id) {
      this.bus.$emit('busChangeHead', '3')
      this.$nextTick(function () {
        this.bus.$emit('busChangeAppCenter', id)
      })
    }
  }
}
</script>

<style scoped>
  .el-menu {
    border-right:0!important;
    height: 100%;
  }
  .el-menu-item{
    height: auto;
  }
  .itemLabel{
    font-size: 16px;
    color: black;
  }
  .el-menu-item .el-image{
    width: 40px;
    height: 40px;
    padding-top: 20px;
    padding-left:  8px;
    padding-right:  8px;
    padding-bottom: 20px
  }
  #mainLeftFixDiv{
    margin-left: 5%;
    margin-right: 5%;
  }

  #mainAsideTop{
    background: #55C235;
    height: 60px;
  }
  #mainAsideH{
    font-size: 19px;
    color: #ffffff;
    padding-left: 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainLeft.vue